import { isNonEmptyString, isPlainObject } from "@sindresorhus/is";

export type LocalesData = {
	readonly edges: readonly {
		readonly node: {
			readonly ns: string | null;
			readonly data: string | null;
			readonly language: string | null;
		};
	}[];
};

// https://github.com/microapps/gatsby-plugin-react-i18next/issues/179#issuecomment-1682196786

const useHeadTranslation = (
	localesData: LocalesData,
): { t: (key: string) => string } => {
	const edges = localesData.edges.filter(
		(edge) => edge.node.language === process.env.GATSBY_LANGUAGE,
	);

	return {
		t: (key) => {
			const pathSegments = key.split(".");

			const namespace = pathSegments[0];

			// TODO: Add type check
			const translations = JSON.parse(
				edges.find((edge) => edge.node.ns === namespace)?.node.data ?? "[]",
			) as Record<string, string>;

			// I don't like that this is really hard to understand. It's essentially letting us do `translations['about.title']` where "about.title" is dynamic. 🤔
			let value: string | Record<string, string> | undefined = translations;
			for (const pathSegment of pathSegments) {
				if (!isPlainObject(value) || !value[pathSegment]) {
					value = undefined;
					break;
				} else {
					value = value[pathSegment];
				}
			}
			return isNonEmptyString(value) ? value : key;
		},
	};
};

export default useHeadTranslation;
